/* eslint-disable react/jsx-props-no-spreading */
import { FeatureToggles } from "@paralleldrive/react-feature-toggles";
import React from "react";
import { useCongress } from "../hooks";

const FeatureProvider = ({ children }) => {
  const { congress } = useCongress();
  const features = [
    "program",
    "sessions",
    "companies",
    "eposters",
    "socialwall",
    "experts",
    "forum",
    "chat",
    "my_badge",
    "presentation"
  ];
  const featureMap = {
    program: congress.enableFeatureProgram,
    sessions: congress.enableFeatureSessions,
    companies: congress.enableFeatureExhibitions,
    eposters: congress.enableFeatureEposters,
    socialwall: congress.enableFeatureSocialWall,
    experts: congress.enableFeatureExperts,
    forum: congress.enableFeatureForum,
    chat: congress.enableFeatureChat,
    my_badge: congress.enableFeatureMyBadge,
    presentation: congress.enableFeaturePresentation
  };
  const availableFeatures = features.filter(x => featureMap[x]);
  return <FeatureToggles features={availableFeatures}>{children}</FeatureToggles>;
};

export default FeatureProvider;
